import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiEnvironmentService, TemplateService } from '../../services';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'hdw-header',
  templateUrl: './hdw-header.component.html',
  styleUrls: ['./hdw-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HdwHeaderComponent implements OnInit {
  headerHtml: SafeHtml = '';
  constructor(
    private templateService: TemplateService,
    private sanitizer: DomSanitizer,
    private apiService: ApiEnvironmentService
  ) {}

  ngOnInit(): void {
    this.templateService.getHeaderHtml().subscribe({
      next: html => {
        if (html.startsWith('"') && html.endsWith('"')) {
          html = html.slice(1, -1);
        }
        // unescape quotes
        html = html.replace(/\\"/g, '"');
        // optional: unescape newlines
        html = html.replace(/\\n/g, '');
        this.headerHtml = this.sanitizer.bypassSecurityTrustHtml(html);
        setTimeout(() => {
          this.loadScripts();
        });
      },
      error: err => {
        console.error('Failed to load header HTML', err);
      }
    });
  }

  loadScripts() {
    const scriptPaths = [
      '/public/uswds/js/uswds-init.min.js',
      '/common/js/svg-loader.js',
      '/public/uswds/js/uswds.min.js',
      '/common/js/uswds-force-reload.js'
    ];
    for (const path of scriptPaths) {
      const script = document.createElement('script');
      script.src = this.apiService.getuxDomain() + path;
      script.defer = true;
      script.onload = () => {
        console.log(`${script.src} loaded`);
      };
      document.body.appendChild(script);
    }
  }
}
